import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flag, Dropdown, Card, Responsive } from 'semantic-ui-react';
import i18next from 'i18next';
import { changeLanguage } from '../../actions';

import './LanguagePicker.scss';

const flags = {
    he: 'il',
    en: 'gb',
};

const trigger = (language) => {    
    return (
        <span>
            <Flag className="language-flag" name={language.flag} />
            <span className="language-label">{i18next.t(`language.${language.key}`)}</span>
        </span>
    );
};

const LanguagePicker = () => {
    const dispatch = useDispatch();
    const language = useSelector(state => state.app.language);
    const languages = useSelector(state => state.app.languages);

    if (!language || languages.length <= 1) return null;

    const options = languages.map(key => ({ key, value: key, text: i18next.t(`language.${key}`), flag: flags[key] }));

    return (
        <Card className="pi language-picker">
            <Responsive maxWidth={768}>
                <Dropdown
                    trigger={trigger(options.find(l => l.key === language))}
                    options={options}
                    direction='left'
                    pointing={`top ${i18next.dir() === 'rtl' ? 'right' : 'left'}`}
                    icon={null}
                    value={language}
                    onChange={(e, { value }) => {
                        dispatch(changeLanguage(value));
                    }}
                />
            </Responsive>
            <Responsive minWidth={769}>
                <Dropdown
                    trigger={trigger(options.find(l => l.key === language))}
                    options={options}
                    direction='left'
                    pointing={`top ${i18next.dir() === 'rtl' ? 'right' : 'left'}`}
                    icon={null}
                    value={language}
                    onChange={(e, { value }) => {
                        dispatch(changeLanguage(value));
                    }}
                />
            </Responsive>


        </Card>
    );
};

export default LanguagePicker;
